  
  const DELIVERY_CODES = {
    DELIVERY_CLEAR: 'DC',
    DELIVERY_EXCEPTION: 'DE',
    RETURN: 'RTN',
    TENDERED_TO_AGENT: 'TA',
  };
  
  const accessorialsList=[
    {name:"LG",labelText:"Liftgate",isChecked:false},
    {name:"ISD",labelText:"Inside Delivery",isChecked:false},
    {name:"HANDU",labelText:"Hand Unload",isChecked:false},
    {name:"LIMIT",labelText:"Limited Access",isChecked:false},
    {name:"SORT",labelText:"Sort & Segregate",isChecked:false},
    {name:"RESDEL",labelText:"Residential",isChecked:false}
]
  const ExceptionList = [
    {
      code: 'DD',
      description: 'Delivered Damaged',
      group: 'Delivery',
      isException: true,
      isRedeliveryCharge: false,
    },
    {
      code: 'DO',
      description: 'Delivered Over',
      group: 'Delivery',
      isException: true,
      isRedeliveryCharge: false,
    },
    {
      code: 'DS',
      description: 'Delivered Short',
      group: 'Delivery',
      isException: true,
      isRedeliveryCharge: false,
    },
    {
      code: 'PR',
      description: 'Partially Refused',
      group: 'Delivery',
      isException: true,
      isRedeliveryCharge: false,
    },
  ];
  
  const LimitedAccessList = [
    {value: 'LES', label: 'Extra Security', sort: '1'},
    {
      value: 'LNS',
      label:
        'Non-standard equipment - customer can only be accessed with a straight truck',
      sort: '2',
    },
    {
      value: 'LNP',
      label: 'Not open to public during normal hours',
      sort: '3',
    },
    {
      value: 'LMN',
      label:
        'Mine - includes all facilities at mine site (warehouses, office, etc.)',
      sort: '4',
    },
    {
      value: 'LCO',
      label: 'Construction site - must be a true job site',
      sort: '5',
    },
    {
      value: 'LMI',
      label:
        'Military installation - when required to enter a US military installation',
      sort: '6',
    },
    {
      value: 'LMP',
      label: 'Prison - when required to enter a secured area',
      sort: '7',
    },
    {value: 'LMS', label: 'Mini-storage facility', sort: '8'},
    {value: 'LSC', label: 'School', sort: '9'},
    {value: 'LMC', label: 'Church', sort: '10'},
    {
      value: 'LFC',
      label:
        'Fair/Carnival - site where the consignee does not have a permanent location',
      sort: '11',
    },
    {value: 'LDG', label: 'Lodging', sort: '12'},
    {value: 'LHL', label: 'Hospital', sort: '13'},
    {value: 'LNH', label: 'Nursing Home/Assisted Living', sort: '14'},
    {value: 'LAT', label: 'Airport', sort: '15'},
    {value: 'LCA', label: 'Casino', sort: '16'},
    {value: 'LPP', label: 'Power Plant', sort: '17'},
    {value: 'LRT', label: 'Resort', sort: '18'},
    {value: 'LGF', label: 'Golf Course', sort: '19'},
    {value: 'LCC', label: 'Country Club', sort: '20'},
    {value: 'LFH', label: 'Funeral Home', sort: '21'},
    {value: 'LUS', label: 'Utility Site', sort: '22'},
    {value: 'LPT', label: 'Port', sort: '23'},
    {value: 'LAP', label: 'Amusement Park', sort: '24'},
    {value: 'LPA', label: 'Park', sort: '25'},
    {value: 'LMA', label: 'Marina', sort: '26'},
    {value: 'LCN', label: 'Convention Center', sort: '27'},
    {value: 'LPW', label: 'Pier/Wharf', sort: '28'},
    {value: 'LDC', label: 'Day Care/Preschool', sort: '29'},
    {value: 'LNU', label: 'Nuclear Power Plant', sort: '30'},
    {value: 'LSP', label: 'State/National Park', sort: '31'},
    {value: 'LCY', label: 'Cemetery', sort: '32'},
    {value: 'LSK', label: 'Ski Resort', sort: '33'},
  ];
  
  const ReturnCodeList = [
    {
      value: 'RF',
      label: 'Refused',
      group: 'Return',
      isException: true,
      isRedeliveryCharge: false,
    },
    {
      value: 'RD',
      label: 'Refused (Damaged)',
      group: 'Return',
      isException: true,
      isRedeliveryCharge: false,
    },
    {
      value: 'CC',
      label: 'Consignee Closed',
      group: 'Return',
      isException: false,
      isRedeliveryCharge: false,
      sort: 1,
    },
    {
      value: 'CCR',
      label: 'Closed Redelivery',
      group: 'Return',
      isException: false,
      isRedeliveryCharge: true,
      sort: 2,
    },
    {
      value: 'BK',
      label: 'Breakdown',
      group: 'Return',
      isException: false,
      isRedeliveryCharge: false,
      sort: 3,
    },
    {
      value: 'BNF',
      label: 'Bill No Freight',
      group: 'Return',
      isException: true,
      isRedeliveryCharge: false,
      sort: 4,
    },
    {
      value: 'WA',
      label: 'Wrong Address',
      group: 'Return',
      isException: false,
      isRedeliveryCharge: true,
      sort: 5,
    },
    {
      value: 'CO',
      label: 'Cut Off',
      group: 'Return',
      isException: false,
      isRedeliveryCharge: false,
      sort: 6,
    },
    {
      value: 'UL',
      label: 'Unable to Locate',
      group: 'Return',
      isException: false,
      isRedeliveryCharge: false,
      sort: 7,
    },
    {
      value: 'HOL',
      label: 'Holiday',
      group: 'Return',
      isException: false,
      isRedeliveryCharge: false,
      sort: 8,
    },
    {
      value: 'CNM',
      label: 'Collect or COD No Money',
      group: 'Return',
      isException: false,
      isRedeliveryCharge: true,
      sort: 9,
    },
    {
      value: 'ML',
      label: 'Terminal Misload',
      group: 'Return',
      isException: false,
      isRedeliveryCharge: false,
      sort: 10,
    },
    {
      value: 'CDC',
      label: 'Consignee Dock Congestion',
      group: 'Return',
      isException: false,
      isRedeliveryCharge: false,
      sort: 11,
    },
    {
      value: 'MA',
      label: 'Missed Appointment',
      group: 'Return',
      isException: false,
      isRedeliveryCharge: false,
      sort: 12,
    },
    {
      value: 'NB',
      label: 'Freight No Bill',
      group: 'Return',
      isException: true,
      isRedeliveryCharge: false,
      sort: 13,
    },
    {
      value: 'DAC',
      label: 'Appointment Cancelled',
      group: 'Return',
      isException: false,
      isRedeliveryCharge: true,
      sort: 14,
    },
    {
      value: 'DAR',
      label: 'Appointment Required',
      group: 'Return',
      isException: false,
      isRedeliveryCharge: true,
      sort: 15,
    },
    {
      value: 'PW',
      label: 'Poor Weather Conditions',
      group: 'Return',
      isException: false,
      isRedeliveryCharge: false,
      sort: 16,
    },
    {
      value: 'BT',
      label: 'Bobtail Required',
      group: 'Return',
      isException: false,
      isRedeliveryCharge: false,
      sort: 17,
    },
    {
      value: 'LG',
      label: 'Liftgate Required',
      group: 'Return',
      isException: false,
      isRedeliveryCharge: false,
      sort: 18,
    },
    {
      value: 'C19',
      label: 'Returned COVID19',
      group: 'Return',
      isException: false,
      isRedeliveryCharge: false,
      sort: 19,
    },
  ];
  
  const AccessorialList = [
    {description: 'Liftgate', code: 'LGATE', type: 'D'},
    {description: 'Inside Delivery', code: 'ISD', type: 'D'},
    {description: 'Hand Unload', code: 'HANDU', type: 'D'},
    {description: 'Sort & Segregate', code: 'SORT', type: 'D'},
    {description: 'Limited Access', code: 'LIMIT', type: 'D'},
    {description: 'Residential', code: 'RESDEL', type: 'D'},
    {description: 'Liftgate', code: 'LGATEP', type: 'P'},
    {description: 'Marking or Tagging', code: 'MARKO', type: 'P'},
    {description: 'Inside Pickup', code: 'ISPU', type: 'P'},
    {
      description: 'Limited Access',
      code: 'LIMITP',
      type: 'P',
    },
    {description: 'Residential', code: 'RESPU', type: 'P'},
  ];
  
  const AccessorialExclusionList = [
    {code: 'RESDEL', excluionCodes: [['LIMIT'], ['ISD']]},
    {code: 'RESPU', excluionCodes: [['LIMITP'], ['ISPU']]},
    {code: 'HANDU', excluionCodes: [['LGATE'], ['SORT', 'LGATE']]},
  ];
  
  const OSDPhoneNumber = '1 (888) 400-7006';
  
  const countries = [
    {code: 'US', name: 'US'},
    {code: 'CN', name: 'Canada'},
    {code: 'MX', name: 'Mexico'},
  ];
  
  const states = [
    {code: 'AL', name: 'Alabama', country: 'US'},
    {code: 'AK', name: 'Alaska', country: 'US'},
    {code: 'AZ', name: 'Arizona', country: 'US'},
    {code: 'AR', name: 'Arkansas', country: 'US'},
    {code: 'CA', name: 'California', country: 'US'},
    {code: 'CO', name: 'Colorado', country: 'US'},
    {code: 'CT', name: 'Connecticut', country: 'US'},
    {code: 'DE', name: 'Delaware', country: 'US'},
    {code: 'DC', name: 'District of Columbia', country: 'US'},
    {code: 'DR', name: 'DOMINICAN REPUBLIC', country: 'US'},
    {code: 'FL', name: 'Florida', country: 'US'},
    {code: 'GA', name: 'Georgia', country: 'US'},
    {code: 'GU', name: 'Guam', country: 'US'},
    {code: 'HI', name: 'Hawaii', country: 'US'},
    {code: 'ID', name: 'Idaho', country: 'US'},
    {code: 'IL', name: 'Illinois', country: 'US'},
    {code: 'IN', name: 'Indiana', country: 'US'},
    {code: 'IA', name: 'Iowa', country: 'US'},
    {code: 'KS', name: 'Kansas', country: 'US'},
    {code: 'KY', name: 'Kentucky', country: 'US'},
    {code: 'LA', name: 'Louisiana', country: 'US'},
    {code: 'ME', name: 'Maine', country: 'US'},
    {code: 'MD', name: 'Maryland', country: 'US'},
    {code: 'MA', name: 'Massachusetts', country: 'US'},
    {code: 'MI', name: 'Michigan', country: 'US'},
    {code: 'MN', name: 'Minnesota', country: 'US'},
    {code: 'MS', name: 'Mississippi', country: 'US'},
    {code: 'MO', name: 'Missouri', country: 'US'},
    {code: 'MT', name: 'Montana', country: 'US'},
    {code: 'NE', name: 'Nebraska', country: 'US'},
    {code: 'NV', name: 'Nevada', country: 'US'},
    {code: 'NH', name: 'New Hampshire', country: 'US'},
    {code: 'NJ', name: 'New Jersey', country: 'US'},
    {code: 'NM', name: 'New Mexico', country: 'US'},
    {code: 'NY', name: 'New York', country: 'US'},
    {code: 'NC', name: 'North Carolina', country: 'US'},
    {code: 'ND', name: 'North Dakota', country: 'US'},
    {code: 'OH', name: 'Ohio', country: 'US'},
    {code: 'OK', name: 'Oklahoma', country: 'US'},
    {code: 'OR', name: 'Oregon', country: 'US'},
    {code: 'PA', name: 'Pennsylvania', country: 'US'},
    {code: 'PR', name: 'Puerto Rico', country: 'US'},
    {code: 'RI', name: 'Rhode Island', country: 'US'},
    {code: 'SC', name: 'South Carolina', country: 'US'},
    {code: 'SD', name: 'South Dakota', country: 'US'},
    {code: 'TN', name: 'Tennessee', country: 'US'},
    {code: 'TX', name: 'Texas', country: 'US'},
    {code: 'TT', name: 'Trust Territories of the Pacific', country: 'US'},
    {code: 'UT', name: 'Utah', country: 'US'},
    {code: 'VT', name: 'Vermont', country: 'US'},
    {code: 'VI', name: 'Virgin Islands', country: 'US'},
    {code: 'VA', name: 'Virginia', country: 'US'},
    {code: 'WA', name: 'Washington', country: 'US'},
    {code: 'WV', name: 'West Virginia', country: 'US'},
    {code: 'WI', name: 'Wisconsin', country: 'US'},
    {code: 'WY', name: 'Wyoming', country: 'US'},
    {code: 'AB', country: 'CN', name: 'Alberta'},
    {code: 'BC', country: 'CN', name: 'British Columbia'},
    {code: 'MB', country: 'CN', name: 'Manitoba'},
    {code: 'NB', country: 'CN', name: 'New Brunswick'},
    {code: 'NL', country: 'CN', name: 'Newfoundland & Labrador'},
    {code: 'NS', country: 'CN', name: 'Nova Scotia'},
    {code: 'NT', country: 'CN', name: 'Northwest Territories'},
    {code: 'NW', country: 'CN', name: 'Northwest Territories'},
    {code: 'ON', country: 'CN', name: 'Ontario'},
    {code: 'PE', country: 'CN', name: 'Prince Edward Island'},
    {code: 'PQ', country: 'CN', name: 'Quebec'},
    {code: 'QC', country: 'CN', name: 'Quebec'},
    {code: 'SK', country: 'CN', name: 'Saskatchewan'},
    {code: 'YT', country: 'CN', name: 'Yukon Territory'},
    {code: 'NU', country: 'CN', name: 'Nunavut'},
    {code: 'CA', country: 'CN', name: 'Canada'},
    {code: 'MX', country: 'MX', name: 'Mexico'},
  ];

  const deliveryStatusList=[
    {value:"DC",labelText:"Delivered Clear"},
    {value:"DE",labelText:"Delivery Exception"},
    {value:"RTN",labelText:"Return"},
    {value:"TA",labelText:"Tendered to an Agent"}
  ]

  const allProsDeliveryStatusList=[
    {value:"DC",labelText:"All Delivered Clear"},
    {value:"RTN",labelText:"All Returned"},
    {value:"TA",labelText:"All Tendered to an Agent"}
  ]

  const osndRadioLabelList=[
    {value:"DD",labelText:"Delivered Damaged"},
    {value:"DO",labelText:"Delivered Over"},
    {value:"DS",labelText:"Delivered Short"},
    {value:"PR",labelText:"Partially Refused"}
  ]

  const hazmatEmergencyPhone = '8004249300';
  
  const consigneeList = [];
  const StaticData = {
    AccessorialList,
    ExceptionList,
    LimitedAccessList,
    ReturnCodeList,
    AccessorialExclusionList,
    OSDPhoneNumber,
    countries,
    states,
    consigneeList,
    hazmatEmergencyPhone,
    accessorialsList,
    deliveryStatusList,
    osndRadioLabelList,
    allProsDeliveryStatusList
  };
  
  export default StaticData;
  